import {
  Box,
  Center,
  FormControl,
  FormLabel,
  HStack,
  Input,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Stack,
  Text,
  Textarea,
  SlideFade,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";
import { PROTECTED_PATHS } from "../../../app/constants";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import DatePicker from "react-multi-date-picker";
import { PrimaryButton } from "../../../components/CustomButton";
import { ConfirmContractorArtisanPayment } from "./ConfirmContractorArtisanPayment";
import { BsAlarmFill } from "react-icons/bs";
import { vehicleType } from "./data";
import CustomeSpecialReqestModal from "./CustomeSpecialReqestModal";
// import { usePaySpecialRequestfee } from './usePaySpecialRequestfee';
import dayjs from "dayjs";
import { v4 } from "uuid";
import { useState } from "react";
import { transition } from "../../..";
import { PaymentMethod } from "./PaymentMethod";
import { useContext } from "react";
import { UserProfileContext } from "../../../context/userProfileContext";
import { useEffect } from "react";
import { getPricesForSpecialRequest } from "../service";
import { COLORS } from "../../../constants/colors";
const { SPECIAL_GUEST_REQUEST } = PROTECTED_PATHS;

const Vehicles = () => {
  const today = new Date();
  const { userProfile } = useContext(UserProfileContext);
  const { email, _id, tenantCode } = userProfile;
  const [allowToOpen, setallowToOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(false);
  const [numberOfVehicles, setNumberVehicles] = useState(1);
  const [requestFees, setRequestFees] = useState({});
  const cardBg = useColorModeValue(COLORS.primary, COLORS.white);

  const inputStyle = {
    bg: "white",
    rounded: "lg",
    color: "#262636",
  };

  const initialValues = {
    email,
    userId: _id,
    tenantCode,
    type: "vehicle",
    subType: "",
    contactPerson: "",
    contactPersonPhone: "",
    dates: [],
    description: "",
    numberOfGuests: 1,
  };

  const [values, setValues] = useState(initialValues);
  const estateFee =
    values.subType === "Truck"
      ? requestFees?.truckFee
      : requestFees?.tricycleFee || 500;

  useEffect(() => {
    getPricesForSpecialRequest(_id, setRequestFees);
  }, [_id]);

  useEffect(() => {
    const { contactPerson, contactPersonPhone, description, subType, dates } =
      values;
    !contactPerson ||
    !contactPersonPhone ||
    !description ||
    !subType ||
    !dates.length
      ? setallowToOpen(false)
      : setallowToOpen(true);
  }, [values]);

  const onChange = (e) => {
    setValues((prev) => ({
      ...prev,

      [e.target.name]: e.target.value,
    }));
  };

  const handleNumberOfVehicles = (number) => {
    setNumberVehicles(number);
    setValues((prev) => ({ ...prev, numberOfGuests: number }));
  };
  const handleNumberOfDays = (date) => {
    const sortedDate = date.sort((a, b) => a.dayOfYear - b.dayOfYear);

    const formatedDates = sortedDate.map((d) => dayjs(d).format("YYYY-MM-DD"));

    setValues((prev) => ({ ...prev, dates: formatedDates }));
  };

  return (
    <SlideFade in={true} offsetX="-1000px" transition={{ ...transition }}>
      {paymentMethod && <PaymentMethod values={values} />}

      {!paymentMethod && (
        <Stack>
          <Box shadow="sm">
            <Container>
              <Header goto={SPECIAL_GUEST_REQUEST} />
            </Container>
          </Box>
          <Container>
            <FormControl mb="50px" fontSize="12px">
              <Stack pt="15px" pb="50px" spacing="15px">
                <FormLabel color={cardBg}>
                  Choose type of vehicle
                  <Select
                    {...inputStyle}
                    name="subType"
                    color={COLORS.green}
                    value={values.subType}
                    onChange={onChange}
                    placeholder="Select type of vehicle"
                    mt="5px"
                  >
                    {vehicleType.map((opt) => (
                      <option key={v4()}>{opt}</option>
                    ))}
                  </Select>
                </FormLabel>

                <FormLabel color={cardBg}>
                  Name of contact person
                  <Input
                    {...inputStyle}
                    name="contactPerson"
                    onChange={onChange}
                    mt="5px"
                  />
                </FormLabel>
                <FormLabel color={cardBg}>
                  Phone number of contact person
                  <Input
                    {...inputStyle}
                    name="contactPersonPhone"
                    onChange={onChange}
                    type="number"
                    mt="5px"
                  />
                </FormLabel>
                <FormLabel color={cardBg}>
                  Vehicle plate number (Optional)
                  <Input
                    {...inputStyle}
                    name="vehiclePlateNumber"
                    onChange={onChange}
                    mt="5px"
                  />
                </FormLabel>
                <HStack justify="space-between">
                  <FormLabel fontSize="13px" color={cardBg}>
                    Total number of <br />
                    Vehicles coming in
                    <NumberInput
                      w="100px"
                      min={0}
                      value={numberOfVehicles}
                      onChange={handleNumberOfVehicles}
                      mt="5px"
                    >
                      <NumberInputField textAlign="center" {...inputStyle} />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  </FormLabel>
                  <Box>
                    <FormLabel m="0" color={cardBg}>
                      Choose day(s)
                    </FormLabel>
                    <Center className="vehicle" position="relative">
                      <DatePicker
                        placeholder={dayjs(today).format("DD-MMM-YYYY")}
                        multiple="true"
                        minDate={today}
                        onChange={handleNumberOfDays}
                      />
                      <Box pos="absolute" pointerEvents="none" right="15px">
                        <BsAlarmFill size="20px" />
                      </Box>
                    </Center>
                  </Box>
                </HStack>

                <FormLabel>
                  <HStack justify="space-between" py="3">
                    <Box>
                      <Text color={cardBg}>Access fee</Text>
                      <Text fontWeight="600" color={cardBg}>
                        {numberOfVehicles}{" "}
                        {numberOfVehicles < 2
                          ? values?.subType
                          : `${values?.subType}s`}{" "}
                        for {values.dates.length}{" "}
                        {values?.dates?.length < 2 ? "day" : "days"}
                      </Text>
                    </Box>
                    <Box>
                      <Text color={cardBg}>Total</Text>
                      <Text fontWeight="600" color={cardBg}>
                        &#8358;
                        {estateFee * values.dates.length * numberOfVehicles}
                      </Text>
                    </Box>
                  </HStack>
                  <Flex justify="space-between">
                    <Text color={cardBg}> Reasons for invite</Text>
                    {values.subType && (
                      <Text fontSize="12px">
                        {values.subType} {estateFee}
                      </Text>
                    )}
                  </Flex>

                  <Textarea
                    {...inputStyle}
                    mt="5px"
                    rows="5"
                    resize="none"
                    onChange={onChange}
                    name="description"
                    _placeholder={{ opacity: 1, color: "black" }}
                    placeholder="Type here..."
                  />
                </FormLabel>
              </Stack>

              <CustomeSpecialReqestModal
                allowToOpen={allowToOpen}
                btnTitle={<PrimaryButton btnText="Send Request" />}
              >
                <ConfirmContractorArtisanPayment
                  estateFee={estateFee * values.dates.length * numberOfVehicles}
                  values={values}
                  setValues={setValues}
                  setPaymentMethod={() => setPaymentMethod(true)}
                />
              </CustomeSpecialReqestModal>
            </FormControl>
          </Container>
        </Stack>
      )}
    </SlideFade>
  );
};

export default Vehicles;
